import React, { useCallback } from "react";
import "./NumberInput.css";
import debounce from "lodash.debounce";

const NumberInput_pointFont = ({
  label,
  postLabel,
  onChange,
  value,
  min,
  max,
  onFocusOut,
  disabled,
  step,
  key,
  comp
}) => {  
  const debouncedFocusOut = useCallback(
    debounce(onFocusOut ? onFocusOut : () => {}, 1000),
    []
  );
  const handleInc = () => {
    if (disabled || !onChange) return;
    if (comp==='lineHeight') {
      if (!isNaN(max)) {
        if (value < max) {
          onChange(Number(value) + 0.10);
          debouncedFocusOut();
        }
      } else {
        onChange(Number(value) + 0.10);
        debouncedFocusOut();
      }
    } else {
      if (!isNaN(max)) {
        if (value < max) {
          onChange(Number(value) + 0.1);
          debouncedFocusOut();
        }
      } else {
        onChange(Number(value) + 0.1);
        debouncedFocusOut();
      }
    }
   
  };

  const handleDec = () => {
    if (disabled || !onChange) return;
    if (comp==='lineHeight') {
      if (!isNaN(min)) {
        if (value > min) {
          onChange(Number(value) - 0.10);
          debouncedFocusOut();
        }
      } else {
        onChange(Number(value) - 0.10);
        debouncedFocusOut();
      }
    } else {
      if (!isNaN(min)) {
        if (value > min) {
          onChange(Number(value) - 0.1);
          debouncedFocusOut();
        }
      } else {
        onChange(Number(value) - 0.1);
        debouncedFocusOut();
      }
    }
  
  };

  // =========================================================================

//   const handleMouseWheel = (event) => {
//     // console.log('handleMouseWheel event ', event);   
//     event.preventDefault();

//     if (disabled || !onChange) return;
//     // Use deltaY to determine scroll direction (positive or negative)
//     if (event.deltaY > 0) {
//       onChange(Number(value) ); 
//       debouncedFocusOut();    
//     } else {
//       onChange(Number(value) ); 
//       debouncedFocusOut();     
//     }
//   };

//   const handleKeyDown = (event) => {
//     // console.log('handleKeyDown event = ', event);
//     if (event.key === 'ArrowUp') {
//       onChange(Number(value));
//       debouncedFocusOut();
//     } else if (event.key === 'ArrowDown') {
//       onChange(Number(value));
//       debouncedFocusOut();
//     }
//   };

  return (
    <div className="main-div">
      {label && <span className="number-label">{label}</span>}
      <div className={"btn-div-font " + (disabled ? "disabled" : "")}>
        <div className="main-btn">
          <div onClick={handleInc} className="top-btnFont">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-chevron-up"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <polyline points="6 15 12 9 18 15"></polyline>
            </svg>
          </div>
          <div onClick={handleDec} className="down-btnFont">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-chevron-down"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
        </div>
        <span>
          <input
            type="number"
            class="form-control"
            value={comp==="lineHeight" ? Number(value).toFixed(1) : Number(value).toFixed(1)}
            step={step}
            min={min}
            max={max}
            key={key}
            onChange={(evt) => {
              if (onChange) {
                const value = Math.max(min, Math.min(max, Number(evt.target.value)));
                onChange(value);
              }
            }}            
            // onWheel={handleMouseWheel}
            // onKeyDown={handleKeyDown}
            onBlur={onFocusOut}
            disabled={disabled}
          />
          {postLabel && <span className="value">{postLabel}</span>}
        </span>
      </div>
    </div>
  );
};

export default NumberInput_pointFont;
